import script from "./SettlementStartModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SettlementStartModal.vue?vue&type=script&setup=true&lang=js"

import "./SettlementStartModal.vue?vue&type=style&index=0&id=6d12e624&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d12e624"]])

export default __exports__